export default class Partial {
    constructor (htmlString) {
        this.el = htmlString
        if (typeof this.el === 'string') {
            this.el = this.getHtmlElementFromString(this.el)
        }

        if (this.el) {
            document.addEventListener('partials_close', this.remove.bind(this))
            const closeButton = this.el.querySelector('[data-close-partial]')
            if (closeButton) {
                closeButton.addEventListener('click', this.remove.bind(this))
            }
        }
    }

    remove () {
        if (this.el) {
            this.el.remove()
            this.el = null
        }
    }

    isVisible () {
        return !!this.el
    }

    getHtmlElementFromString (htmlString) {
        const div = document.createElement('div')
        div.innerHTML = htmlString.trim()
        return div.firstChild
    }

    getElement () {
        return this.el
    }
}